import { wrapClientApiCall } from '@kelbongoo/shared-client-react-v2/dist/components/SharedBase/wrapClientApiCall';

export const updateItemQuantity = ({
  retailrestock,
  setRetailRestock,
  createAlert
}) => ({ producerproduct_id, quantity }) => {

  const caller = wrapClientApiCall({
    url: 'boutiquerestocks/update-item',
  })

  return caller({
    params: {
      boutiquerestock_id: retailrestock._id,
      producerproduct_id,
      quantity
    }
  })
    .then(({ updatedDoc }) => {

      const ind = retailrestock.items.findIndex(
        i => i.producerproduct_id === producerproduct_id
      );
      
      let updatedInd = updatedDoc.items.findIndex(
        i => i.producerproduct_id === producerproduct_id
      );

      retailrestock.items[ind].quantity_received = updatedDoc.items[updatedInd].quantity_received;
      return setRetailRestock(retailrestock);
    })
    .catch(err => createAlert({ message: err.message }));
};